import { FloppyDisk } from 'iconoir-react'
import { Button } from 'app/components/ui/button'

export type FloatingSaveShadcnComponentProps = {
  visible: boolean
  isSaving: boolean
  buttonType: 'button' | 'submit'
  buttonLabel: string
  onSave: (() => void) | undefined
  onDiscard?: () => void
  description?: string
  disabled?: boolean
}

export function FloatingSaveShadcnComponent({
  visible,
  isSaving,
  buttonType,
  buttonLabel,
  onSave,
  onDiscard,
  description = `You have unsaved changes that will be lost if you leave this page.`,
  disabled = false,
}: FloatingSaveShadcnComponentProps) {
  if (!visible) return null

  return (
    <div className="fixed bottom-8 left-1/2 z-50 -translate-x-1/2 animate-in fade-in slide-in-from-bottom-4 duration-300">
      <div className="rounded-2xl border border-default bg-surface-raised p-6 shadow-xl backdrop-blur-sm">
        <div className="flex items-center justify-between gap-6">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-strong">Unsaved Changes</h3>
            <p className="text-sm text-subtle">{description}</p>
          </div>
          {onDiscard && (
            <Button type="button" variant="white" size="lg" disabled={isSaving} onClick={onDiscard}>
              Discard
            </Button>
          )}
          <Button
            type={buttonType}
            size="lg"
            onClick={onSave}
            loading={isSaving}
            disabled={isSaving || disabled}
            className="min-w-35"
          >
            {!isSaving && <FloppyDisk className="h-5 w-5" />}
            {isSaving ? `Saving...` : buttonLabel}
          </Button>
        </div>
      </div>
    </div>
  )
}
